import { Text } from '@user-portal/wikr-components';

import * as S from './styled';

import { ArrowTop } from '@/components/Icon';

export interface CollapsiblePanelItem {
    title: string;
    description: string;
    image: string;
}

export interface CollapsiblePanelProps {
    items: CollapsiblePanelItem[];
    expandedText: string;
    collapsedText: string;
    isOpen: boolean;
    onToggle: () => void;
}

export function CollapsiblePanel({ items, expandedText, collapsedText, isOpen, onToggle }: CollapsiblePanelProps) {
    return (
        <S.Wrapper data-testid="collapsible-panel">
            <S.Trigger onClick={onToggle}>
                <Text bold>{isOpen ? expandedText : collapsedText}</Text>
                <S.IconWrapper $isOpen={isOpen}>
                    <ArrowTop />
                </S.IconWrapper>
            </S.Trigger>

            {isOpen && (
                <S.Content data-testid="collapsible-panel-content">
                    {items.map((item, index) => (
                        <S.ItemWrapper>
                            <S.Item key={index}>
                                <S.ItemNumber>
                                    <Text bold>{index + 1}</Text>
                                </S.ItemNumber>
                                <S.ItemBody>
                                    <Text type="small-text-bold" bold>
                                        {item.title}
                                    </Text>
                                    <Text type="small-text" color="text-secondary">
                                        {item.description}
                                    </Text>
                                </S.ItemBody>
                            </S.Item>
                            <S.ImageWrapper>
                                <S.Image src={item.image} role="presentation" />
                            </S.ImageWrapper>
                        </S.ItemWrapper>
                    ))}
                </S.Content>
            )}
        </S.Wrapper>
    );
}
